var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// class definition
import { LitElement, html } from '@horizon/base';
import { HasSlotController } from '@horizon/common/controllers';
import { property } from '@horizon/base/decorators';
import { nothing } from '@horizon/base/html.js';
import BadgeStyles from './badge.css.js';
/**
 *
 * @tag hzn-badge
 * @tagname hzn-badge
 * @summary badge that can pass required information based on tone and intensity.
 */
export class HznBadge extends LitElement {
    constructor() {
        super(...arguments);
        this.hasSlotController = new HasSlotController(this, '[default]', 'trailing-icon');
        /**
         * Sets the label for badge
         */
        this.label = 'Badge';
        /**
         * Sets the background color and text for badge
         */
        this.tone = 'neutral';
        /**
         * When true, increases intensity of background color and text for badge
         */
        this.intense = false;
    }
    render() {
        return html ` <div class="hzn-badge" role="status">
      ${this.hasSlotController.test('leading-icon') ? html `<slot class="leading-icon" name="leading-icon"></slot>` : nothing}
      <span class="label">${this.label || `${this.tone} badge`}</span>
    </div>`;
    }
}
HznBadge.styles = [BadgeStyles];
__decorate([
    property({ type: String, reflect: true })
], HznBadge.prototype, "label", void 0);
__decorate([
    property({ type: String, reflect: true })
], HznBadge.prototype, "tone", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HznBadge.prototype, "intense", void 0);
//# sourceMappingURL=badge.js.map